<template>
    <div class="app-container">
        <el-row :gutter="10">
          <el-col>
            <el-card class="box-card">
                <!--form 组件-->
                <eForm ref="form" :is-add="isAdd" :sup-this="supThis"/>
                <!-- 搜索-->
                <dynamic-search
                    :data="tableFilterList(tableHead)"
                    @search="dataTableSearch">
                    <template v-slot:next>
                        <el-button icon="el-icon-plus" @click="add">新增</el-button>
                    </template>
                </dynamic-search>
                <edit-data-table
                :head="tableHead"
                :data.sync="list"
                :config="{trigger: 'click', mode: 'cell'}"
                :total="total"
                :offset="offset"
                :page="page"
                :loading="loading"
                stripe
                @handlePageChange="dataTablePageChange"
                @handleSizeChange="dataTableSizeChange"
                >
                  <template #toolbar="scope">
                    <el-button type="text" size="mini" icon="el-icon-edit" @click="edit(scope.row)"></el-button>
                    <el-popover :ref="scope.row.id" placement="top" width="180">
                        <p>确定删除本条数据吗？</p>
                        <div style="text-align: right; margin: 0">
                            <el-button size="mini" type="text" @click="$refs[scope.row.id].doClose()">取消</el-button>
                            <el-button :loading="delLoading" type="primary" size="mini" @click="subDelete(scope.row.id)">确定</el-button>
                        </div>
                        <el-button type="text" size="mini" icon="el-icon-delete" slot="reference" class="table-del-btn"></el-button>
                    </el-popover>
                  </template>
                  <template #enabled="{row}">
                      <el-tag :type="row.enabled ? '' : 'info'">{{ row.enabled ? '启用' : '禁用'}}</el-tag>
                  </template>
              </edit-data-table>
            </el-card>
        </el-col>
        </el-row>
    </div>
</template>

<script>
    import "@/components/EditDataTable"
    import DynamicSearch from "@/components/DynamicSearch";
    import DataTableMixin from '@/mixins/DataTableMixin'
    import { del } from "@/api/dept";
    import eForm from "./form";
    import {deepClone} from "@/utils/index";

    export default {
        name: "Dept",
        mixins: [DataTableMixin],
        components: {
            DynamicSearch,
            eForm
        },
        data() {
            return {
                delLoading: false,
                supThis: this,
                isAdd: false,
                treeData: [],
                treeProps: {
                    children: "children",
                    label: "name"
                },
                tableHead: [
                    {
                        label: "名称",
                        prop: "name",
                        query: {
                            type: "input"
                        },
                        sortable: true
                    },
                    {
                        label: "编码",
                        prop: "code",
                        query: {
                            type: "input"
                        }
                    },
                    {
                        label: "上级组织",
                        prop: "parentName"
                    },
                    {
                        label: "是否启用",
                        prop: "enabled",
                        width: 100
                    },
                    {
                        label: "创建时间",
                        prop: "created"
                    },
                ],
                deptId: "",
                deptName: ""
            };
        },
        created() {
          // 列表数据初始化
          this.$nextTick(() => {
            this.dataTableInit();
          });
        },
        methods: {
            dataTableBeforeInit() {
                this._url = '/dept/list'
                const params = { page: this.page, size: this.offset}
                this._params = Object.assign(params,this._query)
                return true
            },
            subDelete(id) {
                this.delLoading = true;
                del(encodeURIComponent(id)).then(res => {
                    this.delLoading = false
                    this.$refs[id].doClose()
                    this.dleTableChangePage()
                    this.dataTableInit()
                    this.$notify({
                        title: '删除成功',
                        type: 'success',
                        duration: 2500
                    })
                }).catch(() => {
                    this.delLoading = false
                    this.$refs[id].doClose()
                });
            },
            add() {
              this.isAdd = true
              const _this = this.$refs.form
            //   _this.form = {
            //     enabled: 'true'
            //   }
               _this.form.sorting = this.total + 1
              _this.dialog = true
            },
            edit(data) {
                this.isAdd = false;
                const _this = this.$refs.form;
                _this.form = deepClone(data);
                // _this.form.enabled = _this.form.enabled.toString();
                _this.dialog = true;
            }
        }
    };
</script>

<style scoped lang="scss">

</style>
